import ApplicationJSONAPIAdapter from 'district-ui-client/adapters/application'
import { service } from '@ember/service'
import config from 'district-ui-client/config/environment'
import { adapterHostAndNamespace } from 'district-ui-client/utils/uri'
import type AuthToken from '@blakeelearning/auth/services/auth-token'

const url = new URL(config.gravityCsvUrl)
export const { host, namespace } = adapterHostAndNamespace(url)

export default class CsvApiAdapter extends ApplicationJSONAPIAdapter {
  host = host

  namespace = namespace

  @service authToken!: AuthToken

  // @ts-expect-error - parent defines this as a property, we override with getter
  get headers() {
    return {
      Authorization: this.authToken.token,
    }
  }
}
